module.exports = __webpack_public_path__ + "static/media/slider_porque_icon7.dd3f463f.svg";